window.loadSignaturePad = (() => {
    let scriptLoadPromise = null;

    return function () {
        if (document.getElementById('signature-pad-script')) {
            return scriptLoadPromise || Promise.resolve();
        }

        scriptLoadPromise = new Promise((resolve, reject) => {
            const script = Object.assign(document.createElement('script'), {
                src: '/build/assets/static/signature_pad/signature_pad.umd.min.js',
                id: 'signature-pad-script',
                onload: resolve,
                onerror: reject,
            });

            document.head.appendChild(script);
        });

        return scriptLoadPromise;
    };
})();

